// SHA-256 for Meta Conversions API. Meta expects trimmed, lower-cased values.
export const hashSHA256 = async (data) => {
  const normalized = String(data ?? "").trim().toLowerCase();
  const dataBuffer = new TextEncoder().encode(normalized);
  const hashBuffer = await crypto.subtle.digest("SHA-256", dataBuffer);
  return Array.from(new Uint8Array(hashBuffer))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
};
